module.exports = __webpack_public_path__ + "img/rocket.6ee1fc00.png";